export { default, pageLimits as newsPageLimits, type NewsPageViewProps } from './NewsPageView';
